/* eslint-disable */
import React from 'react';
import Slider from 'react-slick';
import language from '../../../assets/languages/language';
import { flowPlayerVideoLessonUrl } from '../../../common/constant';

const settings = {
  dots: true,
  infinite: false,
  speed: 500,
  slidesToShow: 4,
  slidesToScroll: 4,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: false,
        dots: true,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        dots: false,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
      },
    },
  ],
  nextArrow: <SampleNextArrow />,
  prevArrow: <SamplePrevArrow />,
};

function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div className={className} style={{ ...style, display: 'block' }} onClick={onClick}>
      <img onClick={onClick} src='../../assets/img/right-arrow.svg' alt='' />
    </div>
  );
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{
        ...style,
        display: 'block',
        fontSize: '60px',
        right: '80px',
        zIndex: '15',
        height: '20px',
        width: '40px',
        opacity: '1',
      }}
      onClick={onClick}
    >
      <img onClick={onClick} src='../../assets/img/left-arrow.svg' alt='' />
    </div>
  );
}
function VideoList({ videos, showFreePremium, gotoVideo }) {
  let count = 0;
  return (
    <div>
      <Slider {...settings}>
        {videos.map((item, index) => {
          return (
            <div key={index}>
              {showFreePremium ? (
                item.free ? (
                  <div className='video-type-free'>{language.LC().FREE}</div>
                ) : (
                  <div className='video-type-primum'>{language.LC().PREMIUM}</div>
                )
              ) : (
                <div />
              )}
              {item.url_id_qq ? (
                <img
                  width='100%'
                  src={
                    item.posterImage
                      ? item.posterImage
                      : flowPlayerVideoLessonUrl(`${item.url_id_qq}-1`)
                  }
                  onError={({ currentTarget }) => {
                    if (!count++) {
                      // Added condition because of infinite loop, this will once only

                      currentTarget.onerror = null; // prevents looping

                      currentTarget.src = flowPlayerVideoLessonUrl(
                        `${item.url_id_qq}-1_2`,
                      );
                    }
                  }}
                  value={index}
                  onClick={() => gotoVideo(index, item)}
                  className='pointer_class slider_row'
                  alt='flow player image'
                />
              ) : (
                <img
                  alt='youtube'
                  width='100%'
                  src={`https://img.youtube.com/vi/${item.url_id}/mqdefault.jpg`}
                  value={index}
                  onClick={() => gotoVideo(index, item)}
                  className='pointer_class slider_row'
                />
              )}
              <strong style={{ padding: '10px' }}> {item.title}</strong>
            </div>
          );
        })}
      </Slider>
    </div>
  );
}

export default VideoList;



// WEBPACK FOOTER //
// ./src/views/ESG/Videos/VideoList.jsx